__turbopack_context__.v({
  "display4": "Heading-module__dTMr2W__display4",
  "h1": "Heading-module__dTMr2W__h1",
  "h2": "Heading-module__dTMr2W__h2",
  "h3": "Heading-module__dTMr2W__h3",
  "h4": "Heading-module__dTMr2W__h4",
  "listingNumbered": "Heading-module__dTMr2W__listingNumbered",
  "listingSection": "Heading-module__dTMr2W__listingSection",
  "listingSectionSmall": "Heading-module__dTMr2W__listingSectionSmall",
  "listingSubheading": "Heading-module__dTMr2W__listingSubheading",
  "listingTitle": "Heading-module__dTMr2W__listingTitle",
  "numberCircle": "Heading-module__dTMr2W__numberCircle",
});
